import { Space } from 'antd';
import React from 'react';

export const HeaderTitle: React.FC<{ logo: any; title?: string }> = ({ logo }) => {
  return (
    <Space size="small">
      <div className="w-14">{logo}</div>
      {/* <span style={{ fontWeight: 400, fontSize: 20 }}>{title}</span> */}
    </Space>
  );
};
